import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';
import { RequestObserverService } from 'src/app/core/services/common/request-observer.service';

@Component({
  selector: 'app-secondary-button',
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.scss'],
})
export class SecondaryButtonComponent implements OnInit {
  @Input() text: string;
  @Input() value: string;
  @Input() pageUrl: string;
  @Input() stateId: string;
  @Input() clickEvent: () => Promise<unknown>;
  @Output() outputParameter: EventEmitter<any> = new EventEmitter<any>();
  disabled: boolean;
  selected = false;
  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'primary',
    size: <LoaderSize>'small',
  };

  constructor(
    private router: Router,
    private requestObserver: RequestObserverService
  ) {}

  ngOnInit(): void {
    this.disabled = this.stateId === '-1';
  }

  async submit(selectedText: string) {
    this.selected = true;

    this.outputParameter.emit(selectedText);

    this.requestObserver.beginRequest();
    if (this.clickEvent !== undefined) {
      const response = await this.clickEvent()
        .then((res: unknown) => {
          return res;
        })
        .catch((exception) => {
          this.selected = false;
          this.requestObserver.endRequest();
          return false;
        });
      if (!response) {
        this.selected = false;
        this.requestObserver.endRequest();
        return response;
      }
    }
    this.requestObserver.endRequest();
    this.selected = false;
    return true;
  }
}
